import { render } from "./ApplicationForm.vue?vue&type=template&id=06015a20&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"

import "./ApplicationForm.vue?vue&type=style&index=0&id=06015a20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06015a20"]])

export default __exports__